import Config from '../config/config';
import AuthorizationActionType from "../actiontype/authorization.actiontype";
import AuthService from '../services/auth.service';
// import CookieManagerService from "../services/cookie.service"
import { showLoader, hideLoader } from "./app.action";
import { openLoginModal, openErrorModal, openOtpModal, openNoAccountFoundModal, openSsoModal, closeModal, openOtpModalV2 } from './app-modal.action';
import { OtpModalActionType } from '../actiontype/otp-modal.actiontype';
import { otpSentFailed } from "./login-modal.action";
import { AlertMessageModalConstant } from "../constants/alert-message.constant";
import { AppModalConstant } from "../constants/app-modal.constant";
import SsoModalService from "../services/sso-modal.service";
import { SsoModalActionType } from "../actiontype/sso-modal.actiontype";
import { setSelectedSiNumber, setSelectedLob, proceedAccToUserPreference } from "./sso-modal.action";
import { DeviceType } from "../constants/device-type.constant";
import Modals from '../constants/modal.enum';
import { LocalStorageService } from "../services/localstorage.service";
import { enableOtpSection } from './otp-modal.action';
import UtilService from '../services/util.service';
import ApiStatus from '../constants/api-status.enum';
import { returnToHome } from './dnd-app.action';
import { setTokensInLocalStorage } from "../services/auth.service-utils";
import { SentryService } from '../services/sentry-service';

//Check if user logged in or not
export const checkIfUserLoggedIn = () => dispatch => {
    dispatch(showLoader());
    dispatch(loginInfoLoading());
    AuthService.checkIfUserLoggedIn().then(
        res => {
            dispatch(hideLoader());
            if (res && res['data']) {
                const response = res['data'];
                const loggedInNumber = response['loginUserId'];
                dispatch(loginInfoSuccess(response));
                if (response['userLoggedIn'] || (response['data'] && response['data']['userLoggedIn'])) {
                    dispatch(setUserAuthorized());
                    dispatch(setUserLoggedInNumber(loggedInNumber));
                }
                else {
                    LocalStorageService.deleteAccessToken()
                    dispatch(openOtpModalV2(false))
                }
            }
            else {
                LocalStorageService.deleteAccessToken()
                dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
            }
        },
        error => {
            dispatch(hideLoader());
            LocalStorageService.deleteAccessToken()
            dispatch(loginInfoError(error));
            // if (error && error['response'] && error['response']['data'] === AppModalConstant.UNAUTHORIZED) {
                    dispatch(openOtpModalV2(false))
            // }
            // else {
            //     dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
            // }
        }
    )
}

export const setAppLoginToken = bearerToken => {
    return {
        type: AuthorizationActionType.SET_MOBILE_APP_AUTH_TOKEN,
        payload: bearerToken
    }
}

export const setSelectedNumber = selectedNumber => {
    return {
        type: AuthorizationActionType.SET_SELECTED_NUMBER,
        payload: selectedNumber
    }
}

//Check User
export const checkUser = () => (dispatch, getState) => {
    const state = getState();
    const userId = state.loginModalInfo.userId;
    dispatch(checkUserLoading());
    AuthService.checkUser(userId).then(
        res => {
            if (res && res['data']) {
                const response = res['data'];
                dispatch(checkUserSuccess(response));
                if (response && response['requestkey']) {
                    dispatch(setRequestKey(response['requestkey']));
                    dispatch(generateOtp());
                }
                else {
                    dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
                }
            }
            else {
                dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
            }
        },
        error => {
            console.log(error);
            dispatch(checkUserError(error));
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    )
}

//generate otp
export const generateOtp = () => (dispatch, getState) => {
    const state = getState();
    const userId = state.loginModalInfo.userId;
    dispatch(generateOtpLoading());
    const extraInfo = {
        mobileNumber: (state.loginModalInfo && state.loginModalInfo.userId) || ""
    }
    AuthService.generateOtpApiService(userId).then(
        (res) => {
            if (res && res["data"]) {
                const response = res["data"];
                dispatch(generateOtpSuccess(response));
                if (response) {
                    if (response.status === "success") {
                        dispatch(enableOtpSection());
                    } else {
                        const otpSentFailure = {
                            status: true,
                            message: AlertMessageModalConstant.OTHER_NUMBER_OTP_ERROR,
                        };
                        dispatch(otpSentFailed(otpSentFailure));
                    }
                    // show otp section in OtpModalV2
                }
            } else {
                dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
            }
        },
        (error) => {
            SentryService.captureApiError({errorInfo: error,url:"", method: 'POST',options:{},body:{}, extraInfo})
            console.log(error);
            dispatch(generateOtpError(error));
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    );
};

// //validate otp
// export const validateOtp = () => (dispatch, getState) => {
//     const state = getState();
//     const requestkey = state.userInfo.requestKey;
//     const enteredOtp = state.otpModalInfo.enteredOtp;
//     dispatch(validateOtpLoading());
//     AuthService.validateOtp(requestkey, enteredOtp).then(
//         res => {
//             if (res && res['data']) {
//                 const response = res['data'];
//                 dispatch(validateOtpSuccess(response));
//                 if (response) {
//                     if (response['result'] === AppModalConstant.SUCCESS_AIRTEL) {
//                         dispatch(authLogin());
//                     }
//                     else if (response['result'] === AppModalConstant.INCORRECT) {
//                         dispatch(incorrectOtp());
//                     }
//                     else if (response['result'] === AppModalConstant.INCORRECT_LIMIT) {
//                         dispatch(incorrectOtpLimit());
//                     }
//                     else {
//                         dispatch(incorrectResponse());
//                     }
//                 }
//             }
//             else {
//                 dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
//             }
//         },
//         error => {
//             //Notification for error to be handled
//             dispatch(validateOtpError(error));
//             dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
//         }
//     )
// }

//validate otp
export const validateOtp = () => (dispatch, getState) => {
    const state = getState();
    const userId = state.loginModalInfo.userId;
    const enteredOtp = state.otpModalInfo.enteredOtp;
    const extraInfo = {
        mobileNumber: (state.loginModalInfo && state.loginModalInfo.userId) || ""
    }
    dispatch(validateOtpLoading());
    AuthService.validateOtpApiService(userId, enteredOtp).then(
        (res) => {
            if (res && res["data"]) {
                const response = res["data"];
                dispatch(validateOtpSuccess(response));
                if (response) {
                    if (response.status === "success") {
                        const { data } = response.data || { data: {} };
                        const { staticToken = "", dynamicToken = "", uid = "" } = data;
                        const authTokensData = {
                            staticToken,
                            dynamicToken,
                            uid,
                            loggedInUser: userId,
                        };
                        setTokensInLocalStorage(authTokensData);
                        LocalStorageService.setAccessToken(response["access_token"]);
                        dispatch(closeModal());
                        dispatch(initAuthSuccess(null));
                    } else if (response["errorMsg"] === AppModalConstant.OTP_INCORRECT) {
                        LocalStorageService.deleteAccessToken();
                        dispatch(incorrectOtp());
                    } else {
                        LocalStorageService.deleteAccessToken();
                        dispatch(incorrectResponse());
                    }
                }
            }
        },
        (error) => {
            //Notification for error to be handled
            SentryService.captureApiError({errorInfo: error,url:"", method: 'POST',options:{},body:{}, extraInfo})
            LocalStorageService.deleteAccessToken();
            dispatch(validateOtpError(error));
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    );
};


//make user login
export const authLogin = () => (dispatch, getState) => {
    const state = getState();
    const requestkey = state.userInfo.requestKey;
    const loggedInNumber = state.loginModalInfo.userId;
    dispatch(authLoginLoading());
    AuthService.authLogin(requestkey).then(
        res => {
            if (res && res['data']) {
                const response = res['data'];
                dispatch(initAuthSuccess(response))
                // dispatch(authLoginSuccess(response));
                // dispatch(setUserAuthorized());
                // dispatch(setUserLoggedInNumber(loggedInNumber));
            }
            else {
                LocalStorageService.deleteAccessToken()
                dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
            }
        },
        error => {
            //Notification for error to be handled
            LocalStorageService.deleteAccessToken()
            dispatch(authLoginError(error));
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    )
}

const initAuthSuccess = (response) => (dispatch, getState) => {
    const state = getState();
    const loggedInNumber = state.loginModalInfo.userId;

    dispatch(authLoginSuccess(response));
    dispatch(setUserAuthorized());
    dispatch(setUserLoggedInNumber(loggedInNumber));
}

//set user logged in number
export const setUserLoggedInNumber = (loggedInNumber) => (dispatch) => {
    dispatch(setLoggedInMobileNumber(loggedInNumber));
    dispatch(fetchSSOProfile());
}


//fetch User SSO Details
export const fetchSSOProfile = () => (dispatch, getState) => {
    const state = getState();
    dispatch(showLoader());
    dispatch(fetchSsoProfileLoading());
    AuthService.fetchSSOProfile().then(
        res => {
            dispatch(hideLoader());
            if (res && res['data']) {
                const response = res['data'];
                dispatch(fetchSsoProfileSuccess(response));
            }
        },
        error => {
            dispatch(hideLoader());
            dispatch(fetchSsoProfileError(error));
        }
    )
}

export const handleSSOProfile = () => (dispatch, getState) => {
    const state = getState()
    const ssoProfileApiStatus = state && state.ssoModalInfo && state.ssoModalInfo.ssoProfileApiStatus ? state.ssoModalInfo.ssoProfileApiStatus : ""
    const ssoProfileApiResponse = state && state.ssoModalInfo && state.ssoModalInfo.ssoProfileApiResponse
    if (ssoProfileApiStatus === ApiStatus.SUCCESS) {
        if (ssoProfileApiResponse) {
            const userPreference = state.dndapp.userPreference;
            const products = ssoProfileApiResponse['products'] ? ssoProfileApiResponse['products'] : [];
            const accountList = SsoModalService.makeAccountList(products, userPreference);
            dispatch(setSSOAccountList(accountList));

            if (accountList.length === 0) {
                //NO ACCOUNT ASSOCIATED FOR GIVEN DEVICE
                const lob = DeviceType[userPreference];
                dispatch(setSelectedLob(lob));
                dispatch(openNoAccountFoundModal(() => { dispatch(returnToHome()) }));
            }
            // else if(accountList.length==1 || (accountList.length > 1 && dataToModal.stateParams.deviceType == 'FIXED_LINE')){
            else if (accountList.length === 1) {
                // ONLY ONE ACCOUNT ASSOCIATED FOR GIVEN DEVICE
                const siNumber = accountList[0].siNumber;
                dispatch(setSelectedSiNumber(siNumber));
                dispatch(setSelectedLob(accountList[0].lob));
                dispatch(closeModal());
                dispatch(proceedAccToUserPreference(siNumber));
            }
            else {
                // MULTIPLE ACCOUNTS EXISTS FOR GIVEN DEVICE
                const siNumber = accountList[0].siNumber;
                dispatch(setSelectedSiNumber(siNumber));
                dispatch(openSsoModal());
            }
        }
        else {
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    }
    else {
        if (ssoProfileApiStatus === ApiStatus.ERROR) {
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    }
}

//logout
export const logout = () => {
    AuthService.logout();
}

//Store request key for authorizations/ otp
export function setRequestKey(requestkey) {
    return { type: AuthorizationActionType.SET_REQUEST_KEY, payload: requestkey };
}

//set SSO Account list
function setSSOAccountList(accountList) { return { type: SsoModalActionType.SET_SSO_ACCOUNT_LIST, payload: accountList } };

//set logged in mobile number
export function setLoggedInMobileNumber(loggedInNumber) { return { type: AuthorizationActionType.SET_LOGGEDIN_MOBILE_NUMBER, payload: loggedInNumber } }

//set user authorized
export function setUserAuthorized() { return { type: AuthorizationActionType.USER_AUTHORIZED } };

//Incorrect Otp
function incorrectOtp() { return { type: OtpModalActionType.INCORRECT_OTP } };

//Incorrect Otp Limit
function incorrectOtpLimit() { return { type: OtpModalActionType.INCORRECT_OTP_LIMIT } };

//Validate otp no response
function incorrectResponse() { return { type: OtpModalActionType.INCORRECT_RESPONSE } };

//set api calls status 
//login info api status
function loginInfoLoading() { return { type: AuthorizationActionType.LOGIN_INFO_LOADING } };
function loginInfoSuccess(response) { return { type: AuthorizationActionType.LOGIN_INFO_SUCCESS, payload: response } };
function loginInfoError(error) { return { type: AuthorizationActionType.LOGIN_INFO_ERROR, payload: error } };
//checkuser api status
function checkUserLoading() { return { type: AuthorizationActionType.CHECK_USER_LOADING } };
function checkUserSuccess(response) { return { type: AuthorizationActionType.CHECK_USER_SUCCESS, payload: response } };
function checkUserError(error) { return { type: AuthorizationActionType.CHECK_USER_ERROR, payload: error } };
//generateOtp api status
function generateOtpLoading() { return { type: AuthorizationActionType.GENERATE_OTP_LOADING } };
function generateOtpSuccess(response) { return { type: AuthorizationActionType.GENERATE_OTP_SUCCESS, payload: response } };
function generateOtpError(error) { return { type: AuthorizationActionType.GENERATE_OTP_ERROR, payload: error } };
//validateOtp api status
function validateOtpLoading() { return { type: AuthorizationActionType.VALIDATE_OTP_LOADING } };
function validateOtpSuccess(response) { return { type: AuthorizationActionType.VALIDATE_OTP_SUCCESS, payload: response } };
function validateOtpError(error) { return { type: AuthorizationActionType.VALIDATE_OTP_ERROR, payload: error } };
//authLogin api status
function authLoginLoading() { return { type: AuthorizationActionType.AUTH_LOGIN_LOADING } };
function authLoginSuccess(response) { return { type: AuthorizationActionType.AUTH_LOGIN_SUCCESS, payload: response } };
function authLoginError(error) { return { type: AuthorizationActionType.AUTH_LOGIN_ERROR, payload: error } };
//fetchssoprofile api status
function fetchSsoProfileLoading() { return { type: AuthorizationActionType.FETCH_SSO_PROFILE_LOADING } };
function fetchSsoProfileSuccess(response) { return { type: AuthorizationActionType.FETCH_SSO_PROFILE_SUCCESS, payload: response } };
function fetchSsoProfileError(error) { return { type: AuthorizationActionType.FETCH_SSO_PROFILE_ERROR, payload: error } };
